
export default function constructTourGeneralPerformance(labels, series) {
    return {
        chart: {
            height: 350,
            type: 'area',
            fontFamily: 'Nunito',
            toolbar: { show: false },
            zoom: {
                enabled: false
            },
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 850,
                animateGradually: {
                    enabled: false,
                    delay: 150
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 350
                }
            },
        },
        //colors: ['#00e396', '#E91E63', '#F44336', '#9C27B0'],
        //colors: ['#3DC08D', '#E96F5E', '#E69C24'],
        stroke: {
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: false,
            formatter: function (val) {
                return val;
            },
            offsetY: 10,
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            }
        },
        series: series,
        xaxis: {
            categories: labels,
            type: 'datetime',
            position: 'bottom',
            labels: {
                offsetY: 0,
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            tooltip: {
                enabled: false,
                offsetY: -35,

            }
        },
        //fill: {
        //    gradient: {
        //        shade: 'light',
        //        type: "horizontal",
        //        shadeIntensity: 0.25,
        //        gradientToColors: undefined,
        //        inverseColors: true,
        //        opacityFrom: 0.1,
        //        opacityTo: 1,
        //        stops: [50, 0, 100, 100]
        //    },
        //},
        yaxis: {
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            forceNiceScale: true,
            labels: {
                show: true,
                formatter: function (val, index) {
                    return val.toFixed(0);
                }
            }
        }
    };
}